import { createApi } from '@shared/redux/createApi';
import { createSlice } from '@reduxjs/toolkit';

const tags = {
  faq: 'faq',
};

export const faqApi = createApi({
  reducerPath: 'faqApi',
  tagTypes: Object.values(tags),
  endpoints: (builder) => ({
    getFaqList: builder.query({
      query: ({ page = 1, limit = 10 }) => ({
        url: `/faq/list?page=${page}&limit=${limit}`,
        method: 'get',
      }),
      transformResponse: (response) => ({
        list: response || [],
        count: 0
      }),
      providesTags: [tags.faq]
    }),
    createFaq: builder.mutation({
      query: (data) => ({
        url: '/faq/create',
        method: 'post',
        body: data
      }),
      invalidatesTags: [tags.faq]
    }),
    updateFaq: builder.mutation({
      query: (data) => ({
        url: '/faq/update',
        method: 'post',
        body: data
      }),
      invalidatesTags: [tags.faq]
    }),
    deleteFaq: builder.mutation({
      query: (sk) => ({
        url: `/faq/delete?sk=${encodeURIComponent(sk)}`,
        method: 'delete'
      }),
      invalidatesTags: [tags.faq]
    }),
  })
});

export const {
  useGetFaqListQuery,
  useCreateFaqMutation,
  useUpdateFaqMutation,
  useDeleteFaqMutation
} = faqApi;
